// @flow

import invariant           from 'invariant';
import createAction        from 'redux-actions/lib/createAction';
import type { CookieType } from '../../config/cookiesConfig';
import cookiesConfig       from '../../config/cookiesConfig';


// -----------------------------------------------------------------------------------------------------------------
// Actions
// -----------------------------------------------------------------------------------------------------------------

// updateCookieSettings
// --------------------

// Types…

export type DisplayCookieNotAllowedModalPayload = {|
  cookieTypes: Array<CookieType>,
|};

export type DisplayCookieNotAllowedModalActionArgs = {|
  ...DisplayCookieNotAllowedModalPayload,
|};

export type DisplayCookieNotAllowedModalAction = {|
  payload: DisplayCookieNotAllowedModalPayload,
|}

export type DisplayCookieNotAllowedModalActionFactory = (DisplayCookieNotAllowedModalActionArgs) => DisplayCookieNotAllowedModalAction;

// Action…

const displayCookieNotAllowedModal: DisplayCookieNotAllowedModalActionFactory = createAction(
  'COOKIE_SETTINGS:COOKIE_BLOCKED_MODAL:DISPLAY',
  ({cookieTypes}) => {
    console.log(cookieTypes);
    for (let cookieType of cookieTypes) {
      invariant(!!cookiesConfig[cookieType], `Invalid cookieType '${cookieType}'.`);
    }

    return {cookieTypes};
  },
);


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default displayCookieNotAllowedModal;



// WEBPACK FOOTER //
// ./src/actions/cookieSettings/displayCookieNotAllowedModal.js